import { actionPotentialScore } from "./GoogleSearchRanking";

export function rankForUserAction(images, query) {
  console.log("rankForUserAction", images.length)
  

  const ranked = images
    .map(img => ({
      ...img,
      _actionPotential: actionPotentialScore(img, query)
    }))
    .sort(
      (a, b) =>
        b._actionPotential - a._actionPotential
    );

  return ranked;
}